var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19V10C4.5 9.68333 4.571 9.38333 4.713 9.1C4.855 8.81667 5.05067 8.58333 5.3 8.4L11.3 3.9C11.65 3.63333 12.05 3.5 12.5 3.5C12.95 3.5 13.35 3.63333 13.7 3.9L19.7 8.4C19.95 8.58333 20.146 8.81667 20.288 9.1C20.43 9.38333 20.5007 9.68333 20.5 10V19C20.5 19.55 20.304 20.021 19.912 20.413C19.52 20.805 19.0493 21.0007 18.5 21H15.5C15.2167 21 14.9793 20.904 14.788 20.712C14.5967 20.52 14.5007 20.2827 14.5 20V15C14.5 14.7167 14.404 14.4793 14.212 14.288C14.02 14.0967 13.7827 14.0007 13.5 14H11.5C11.2167 14 10.9793 14.096 10.788 14.288C10.5967 14.48 10.5007 14.7173 10.5 15V20C10.5 20.2833 10.404 20.521 10.212 20.713C10.02 20.905 9.78267 21.0007 9.5 21H6.5C5.95 21 5.47933 20.8043 5.088 20.413C4.69667 20.0217 4.50067 19.5507 4.5 19Z",
    fill: "#D1FE17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.569e64b617d47e79a542b1f778c8ba33.svg";
export { ForwardRef as ReactComponent };